import { Controller, Path, useFormContext } from "react-hook-form";
import { BLANK_OPTION, CustomerSearchFilters, IMapField, IMapFieldBoolean } from "../../../types";
import { Autocomplete, TextField } from "@mui/material/index";
import { useTranslation } from "react-i18next";

interface CBSearchBooleanAutocompleteControllerProps {
    idField: string,
    formName: Path<CustomerSearchFilters>,
    label: string,
    translateLabel?: string,
    options: IMapFieldBoolean[],
    onChange?: (value: any) => void
   
}

const CBSearchBooleanAutocompleteController = ({
    idField,
    formName,
    label,
    translateLabel,
    options,
    onChange

}: CBSearchBooleanAutocompleteControllerProps) => {

    const { t } = useTranslation('customerbase');
    const formContext = useFormContext<CustomerSearchFilters>();
   

    return (
        <Controller
            control={formContext.control} 
            name={formName}
            render={({field}) => (
                <Autocomplete
                    fullWidth
                    openOnFocus
                    autoHighlight
                    autoSelect
                    id={idField}
                    options={[BLANK_OPTION, ...options]}
                    renderInput={(params:any) => 
                        <TextField 
                            fullWidth
                            {...params}
                            label={t(label)}
                        />
                    }
                    value={options.find((c) => c.value === field.value) || null}
                    getOptionLabel={(option:any) => !!option?.key && !!translateLabel ? t(`${translateLabel}.${option?.key}`) : option?.key}
                    onChange={(_event, value) => {
                        field.onChange(value);
                        onChange?.(value)
                    }}
                />
            )}  
        />

    )

}

export default CBSearchBooleanAutocompleteController;